module.exports = __webpack_public_path__ + "static/media/Project-china.c4c590bc.svg";